import React, { useState } from 'react';
import { Mail, ArrowRight, CheckCircle2 } from 'lucide-react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { toast } from 'sonner';

const EmailSignup = () => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email) {
      setIsSubmitted(true);
      toast.success('Welcome to the GWINS Army!');
      setTimeout(() => {
        setIsSubmitted(false);
        setEmail('');
      }, 3000);
    }
  };

  return (
    <section className="py-20 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#00d4aa]/10 via-[#0a0b0c] to-[#00d4aa]/10" />
      
      {/* Decorative lines */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#00d4aa]/30 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#00d4aa]/30 to-transparent" />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#00d4aa]/10 border border-[#00d4aa]/30 mb-6">
          <Mail className="h-8 w-8 text-[#00d4aa]" />
        </div>

        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-black uppercase text-white mb-4">
          Get <span className="text-[#00d4aa]">Exclusive</span> Access
        </h2>
        <p className="text-white/60 max-w-xl mx-auto mb-8">
          Be first to know about new drops, exclusive deals, and early access to limited edition gear.
        </p>

        {isSubmitted ? (
          <div className="flex items-center justify-center gap-3 text-[#00d4aa]">
            <CheckCircle2 className="h-6 w-6" />
            <span className="font-semibold">You're in! Check your inbox.</span>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <Input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="flex-1 bg-white/5 border-white/10 text-white placeholder:text-white/40 rounded-full px-6 py-6"
            />
            <Button
              type="submit"
              className="bg-[#00d4aa] hover:bg-[#33e0bb] text-[#0a0b0c] font-bold rounded-full px-8 py-6 group"
            >
              Subscribe
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </Button>
          </form>
        )}

        <p className="text-white/40 text-sm mt-4">
          No spam. Unsubscribe anytime.
        </p>
      </div>
    </section>
  );
};

export default EmailSignup;
